/* eslint-disable import/no-cycle */
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../package/actionTypes';
import { startLoader, stopLoader } from '../../../utility/commonFunction';
import {
  setPackageList,
  setPackageDetails,
  updatePackageSuccess,
  createPackageSuccess,
  updatePackageStatusSuccess,
} from '../../package/actions';
import {
  getPackageApi,
  getNextPagePackageApi,
  getPackageByIdApi,
  updatePackageApi,
  createPackageApi,
  updatePackageStatusApi,
} from '../requests/packageRequest';

function* getPackageListHandler(action) {
  if (action.payload?.search) {
    yield delay(1000);
  }

  try {
    yield startLoader('transparent');
    const { data } = yield call(getPackageApi, action.payload);
    yield put(setPackageList(data));
    if (!data?.status) {
      yield toast.error(data?.errors?.message);
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* getNextPagePackageListHandler(action) {
  if (action.payload?.search) {
    yield delay(1000);
  }
  try {
    yield startLoader('transparent');
    const { data } = yield call(getNextPagePackageApi, action.payload);
    if (data) {
      yield put(setPackageList(data));
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* getPackageByIdHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(getPackageByIdApi, action.payload.id);
    if (data) {
      yield put(setPackageDetails(data));
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* updatePackageStatusHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(updatePackageStatusApi, action.payload.id, action.payload.status);
    if (data?.status) {
      yield put(updatePackageStatusSuccess({ id: action.payload.id, status: action.payload.status }));
      yield toast.success(data?.message || 'Package status updated successfully');
    } else {
      yield toast.error(data?.message || 'Failed to update package status');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* updatePackageHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(updatePackageApi, action.payload);
    if (data?.status) {
      yield put(updatePackageSuccess(true));
      yield toast.success(data?.message || 'Package updated successfully');
    } else {
      yield toast.error(data?.message || 'Failed to update package');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* createPackageHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(createPackageApi, action.payload);
    if (data?.status) {
      yield put(createPackageSuccess(true));
      yield toast.success(data?.message || 'Package created successfully');
    } else {
      yield put(createPackageSuccess(false));
      yield toast.error(data?.errors?.form_errors?.name || 'Failed to create package');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

export default function* packageSaga() {
  yield takeLatest(types.GET_PACKAGE_LIST, getPackageListHandler);
  yield takeLatest(types.GET_NEXT_PAGE_PACKAGE_LIST, getNextPagePackageListHandler);
  yield takeLatest(types.GET_PACKAGE_DETAILS, getPackageByIdHandler);
  yield takeLatest(types.UPDATE_PACKAGE, updatePackageHandler);
  yield takeLatest(types.CREATE_PACKAGE, createPackageHandler);
  yield takeLatest(types.UPDATE_PACKAGE_STATUS, updatePackageStatusHandler);
}
